import { ThermometerSnowflake, MessageCircle, Boxes } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { Reveal, ChapterTag, SectionTitle } from "./Reveal";

export function Products() {
  const { content, wa } = useSite();
  const products = content?.products || [];

  return (
    <section id="produk" data-testid="products-section" className="relative py-24 sm:py-32 bg-navy-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterTag number="03" label="Produk & Solusi" />
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <SectionTitle>Katalog Solusi <span className="text-ice">Pendinginan</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-steel text-base">Setiap kebutuhan berbeda. Pilih solusinya, lalu minta penawaran sesuai ukuran dan spesifikasi Anda.</p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {products.map((p, i) => (
            <Reveal key={p.id || i} delay={0.06 * (i % 3)}>
              <article data-testid={`product-card-${i}`} className="group bg-navy-900 border border-glacier/15 rounded-sm overflow-hidden hover:border-ice/50 transition-colors duration-300 flex flex-col h-full">
                <div className="relative h-52 overflow-hidden">
                  {p.image && (
                    <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-950/20 to-transparent" />
                  <span className="absolute bottom-3 left-4 inline-flex items-center gap-1.5 bg-navy-950/85 backdrop-blur border border-ice/40 text-ice font-mono text-xs px-3 py-1.5 rounded-sm" data-testid={`product-temp-${i}`}>
                    <ThermometerSnowflake className="w-3.5 h-3.5" />
                    {p.temperature}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-display text-2xl font-semibold uppercase tracking-wide text-frost">{p.name}</h3>
                  <p className="mt-2.5 text-sm text-steel leading-relaxed flex-1">{p.description}</p>
                  <p className="mt-4 flex items-start gap-2 text-xs text-steel/80">
                    <Boxes className="w-4 h-4 text-glacier shrink-0 mt-0.5" />
                    {p.usage}
                  </p>
                  <a
                    data-testid={`product-cta-${i}`}
                    href={wa(`Halo, saya ingin menanyakan harga ${p.name}. Mohon info penawarannya.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center justify-center gap-2 border border-ice/40 text-ice font-semibold text-sm px-5 py-3 rounded-sm hover:bg-ice hover:text-navy-950 transition-colors duration-200"
                  >
                    <MessageCircle className="w-4 h-4" />
                    Tanya Harga
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-center text-xs text-steel/70 font-mono tracking-wide">
            * Harga ditentukan berdasarkan ukuran & spesifikasi — gunakan tombol "Minta Penawaran" untuk estimasi gratis.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
